import { AnyObject } from '../../types/global'
import { IQueryParamsSchema, QueryParamValue } from './queryParams.storage.types'
import domUtils from '../../utils/dom.utils'

class QueryParamsStorage {
  public set(value: AnyObject, schema: IQueryParamsSchema) {
    const params: Array<{ key: string; value: string }> = []
    for (const item of schema) {
      if (item.type === 'object') {
        this.set(value[item.key], item.children)
      } else {
        const v = this.encodeValue(value[item.key], item.type)
        params.push({ key: item.key, value: v })
      }
    }

    if (params.length) {
      domUtils.batchSetQueryParams(params)
    }
  }

  public get(schema: IQueryParamsSchema): AnyObject {
    const resultingObject: AnyObject = {}
    const queryParams = domUtils.getQueryParams()

    const setRecursive = (schemaPart: IQueryParamsSchema, obj: AnyObject) => {
      for (const item of schemaPart) {
        if (item.type === 'object') {
          obj[item.key] = {}
          setRecursive(item.children, obj[item.key])
        } else {
          const value = this.decodeValue(queryParams[item.key], item.type)
          if (value !== undefined) {
            obj[item.key] = this.decodeValue(queryParams[item.key], item.type)
          }
        }
      }
    }

    setRecursive(schema, resultingObject)
    return resultingObject
  }

  private decodeValue(value: string, type: QueryParamValue['type']) {
    switch (type) {
      case 'string':
        return value
      case 'number':
        return +value
      default:
        return null
    }
  }

  private encodeValue(value: string, type: QueryParamValue['type']) {
    switch (type) {
      case 'string':
        return value === 'null' ? null : value
      case 'number':
        return value.toString()
      default:
        return null
    }
  }
}

const queryParamsStorage = new QueryParamsStorage()
export default queryParamsStorage
